import React from 'react';

const Percentage = ({ value, percentage }) => (
  <div>{value !== '-' ? `${value}%` : `${percentage}%`}</div>
);

export default Percentage;
